<template>
  <div v-if="dataIdentify !==null" class="w-full bg-white pb-16 tab-content mt-6">
    <div
      class="px-4 py-8 mb-4 border-b flex items-center justify-between font-medium text-lg"
    >
      <h2>
        {{ $t('message.selfService.infoEmployee.identifyInfo.identifies') }}
      </h2>
    </div>
    <div class="px-4 pb-1">
      <div class="flex flex-wrap md:flex-no-wrap">
        <div class="w-full w-1/2 mr-4 custom-input mt-10 relative">
          <zt-input
            class="w-full"
            v-model="dataIdentify.nick_name"
            outlined
            readonly
            name="nick_name"
            color="primary"
            :label="$t('message.selfService.infoEmployee.identifyInfo.nickName')"
            data-vs-input="nick_name"
          />
        </div>
        <div class="w-full w-1/2 mr-4 custom-input mt-10 relative">
          <zt-input
            class="w-full"
            :value="genreLabel"
            outlined
            readonly
            disabled
            name="genre"
            :label="$t('message.selfService.infoEmployee.identifyInfo.myGenre')"
            data-vs-select="genre"
          />
        </div>
      </div>
    </div>
  </div>
  <div v-else>
    <div class="w-full md:w-2/3 m-6 py-6">
      <zt-alert color="info" filled :closeIcon="false">
        <template slot="custom-content">
          <div class="flex justify-start items-center">
            <zt-icon name="info-circle-solid" class="text-2xl mr-4"></zt-icon>
            <p>{{ $t('message.selfService.infoEmployee.tab.emptyTab') }}</p>
          </div>
        </template>
      </zt-alert>
    </div>
  </div>
</template>

<script>
import { find } from 'lodash'
export default {
  props: {
    dataIdentify: { type: Object}
  },
  data() {
    return {
      genreOptions: [
        {
          label: this.$t('message.selfService.infoEmployee.identifyInfo.identifyGenre.man'),
          value: 'M'
        },
        {
          label: this.$t('message.selfService.infoEmployee.identifyInfo.identifyGenre.woman'),
          value: 'F'
        },
        {
          label: this.$t('message.selfService.infoEmployee.identifyInfo.identifyGenre.noBinary'),
          value: 'N'
        },
        {
          label: this.$t('message.selfService.infoEmployee.identifyInfo.identifyGenre.other'),
          value: 'U'
        }
      ]
    }
  },
  computed: {
    genreLabel() {
      return this.dataIdentify && this.dataIdentify.genre ? this.getGenre(this.dataIdentify.genre) : ''
    }
  },
  methods: {
    getGenre(genre) {
      const genreOption = find(this.genreOptions, { value: genre })
      return genreOption ? genreOption.label : genre
    }
  },
}
</script>

<style lang="scss" scoped>
.h-12 {
  height: 3rem !important;
}
.tab-content {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.25);
  border-radius: 4px;
}
</style>
